module.exports = __webpack_public_path__ + "img/ewm.24bd6503.png";